<template>
  <component :is="logo" />
</template>

<script>
  export default {
    name: 'ZgLogo',
    components: {
      ZmartaColor: () => import('./logos/ZmartaColor.vue'),
      ZmartaSymbolColor: () => import('./logos/ZmartaSymbolColor.vue'),
      ZmartaWhite: () => import('./logos/ZmartaWhite.vue'),
      ZmartaSymbolWhite: () => import('./logos/ZmartaSymbolWhite.vue'),
      ElsklingColor: () => import('./logos/ElsklingColor.vue'),
      ElsklingSymbolColor: () => import('./logos/ElsklingSymbolColor.vue'),
      ElsklingWhite: () => import('./logos/ElsklingWhite.vue'),
      ElsklingSymbolWhite: () => import('./logos/ElsklingSymbolWhite.vue')
    },
    props: {
      brand: {
        type: String,
        required: false,
        default: 'zmarta',
        validator: value => [
          'zmarta',
          'elskling'
        ].includes(value)
      },
      symbol: {
        type: Boolean,
        required: false,
        default: false
      },
      white: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    computed: {
      logo () {
        let logo = this.brand
        if (this.symbol) logo += '-symbol'

        return this.white
          ? `${logo}-white`
          : `${logo}-color`
      }
    }
  }
</script>
